export function replaceEditWithView(url: string): string {
  return url?.replace(/\/edit\//, "/view/");
}

interface DetailsData {
  Official: Record<string, any>;
  // Personal: Record<string, any>;
  // Financial: Record<string, any>;
  Salary: Record<string, any>;
  // Emergency: Record<string, any>;
  Additional: {
    currentData: number | undefined;
    allData: { additionalFields: any[] };
  };
}

const calculatePercentage = (
  data: Record<string, any>,
  totalFields: number
): number => {
  const filledFields = Object.values(data).filter(
    (value) =>
      value !== undefined &&
      value !== null &&
      !(Array.isArray(value) && value.length === 0)
  ).length;
  return Math.round((filledFields / totalFields) * 100);
};

export const calculateDetailsPercentage = (detailsData: DetailsData) => {
  const output: Record<string, number> = {};

  Object.keys(detailsData).forEach((key) => {
    const section = detailsData[key as keyof DetailsData];
    let percentage = 0;

    if (key === "Additional") {
      const currentLength = section.currentData || 0;
      const totalLength = section.allData?.additionalFields?.length || 0;

      percentage =
        totalLength > 0 ? Math.round((currentLength / totalLength) * 100) : 0;
    } else {
      const totalFields = Object.keys(section).length;
      percentage = calculatePercentage(section, totalFields);
    }

    output[key] = percentage;
  });

  return output;
};
